import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiX, FiMaximize2 } from 'react-icons/fi';

export default function Examples() {
  const [selectedImg, setSelectedImg] = useState(null);

  const items = Array(8).fill({
    img: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1784883805946-image.png',
    title: 'Rzut 2D z wymiarami',
    desc: 'Gotowy rzut wyeksportowany z naszego kreatora. Przejrzysty i czytelny układ, idealny do ofert.'
  });

  return (
    <section id="examples" className="py-24 bg-gray-50/30 border-y border-gray-100">
      <div className="max-w-8xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-[40px] text-[#1F2937] tracking-tight mb-4">Przykładowe realizacje</h2>
          <p className="text-lg text-gray-500 font-normal max-w-2xl mx-auto">
            Zobacz, jak prezentują się projekty przygotowane za pomocą naszego kreatora. Kliknij w obrazek, aby go powiększyć.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {items.map((item, i) => (
            <motion.div 
              key={i}
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              className="flex flex-col gap-4 group cursor-pointer"
              onClick={() => setSelectedImg(item.img)}
            >
              <div className="rounded-xl border border-gray-200 overflow-hidden shadow-sm bg-white relative aspect-[4/3]">
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-300 z-10 flex items-center justify-center opacity-0 group-hover:opacity-100">
                  <div className="bg-white/90 p-3 rounded-full shadow-lg transform scale-90 group-hover:scale-100 transition-transform">
                    <SafeIcon icon={FiMaximize2} className="w-5 h-5 text-gray-900" />
                  </div>
                </div>
                <img 
                  src={item.img} 
                  alt={`Przykład ${i + 1}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="px-1">
                <h3 className="text-[15px] font-semibold text-[#1F2937] mb-1">{item.title}</h3>
                <p className="text-[13px] text-gray-500 leading-relaxed">{item.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Lightbox Overlay */}
      <AnimatePresence>
        {selectedImg && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[100] flex items-center justify-center bg-gray-900/95 p-4 sm:p-10 backdrop-blur-sm"
            onClick={() => setSelectedImg(null)}
          >
            <motion.button
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              className="absolute top-6 right-6 z-[110] p-3 rounded-full bg-white/10 text-white hover:bg-white/20 transition-colors border border-white/10"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedImg(null);
              }}
            >
              <SafeIcon icon={FiX} className="w-6 h-6" />
            </motion.button>

            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ type: "spring", damping: 25, stiffness: 300 }}
              className="relative max-w-7xl w-full flex items-center justify-center"
              onClick={(e) => e.stopPropagation()}
            >
              <img
                src={selectedImg}
                alt="Powiększony rzut"
                className="max-w-full max-h-[85vh] object-contain rounded-lg shadow-2xl border border-white/5"
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}